/**
 * Thin wrapper around the gtag global installed in `public/index.html`.
 *
 * `window.gtag` is missing whenever the tag fails to load — ad blockers strip
 * it for a meaningful share of players — so every call is guarded. Analytics
 * must never be able to break gameplay.
 */
export type AnalyticsParams = Record<
  string,
  string | number | boolean | undefined
>;

export const trackEvent = (name: string, params: AnalyticsParams = {}) => {
  try {
    if (window.gtag) {
      window.gtag('event', name, params);
    }
  } catch {
    // Swallow: a reporting failure is never worth surfacing to the player.
  }
};
